module.exports = __webpack_public_path__ + "clock.00da72d93401f4149ccb.png";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/img/iconos_botones/clock.png
// module id = ../../../../../src/assets/img/iconos_botones/clock.png
// module chunks = styles